// Types de biens
export const apartmentTypes = [
  'Studio',
  'F1',
  'F2',
  'F3',
  'F4',
  'F5',
  'Duplex',
  'Triplex',
  'Loft',
  'Penthouse',
] as const;

export const houseTypes = [
  'Villa',
  'Maison individuelle',
  'Maison de ville',
  'Maison de luxe',
  'Niveau de villa',
  'Maison de campagne',
  'Maison mitoyenne / jumelée',
] as const;

export const conditions = [
  'Neuf',
  'Rénové à neuf',
  'Rénové',
  'Ancien',
  'À rénover',
  'Bon état',
  'Moyen état',
  'Mauvais état',
  'Très bon état',
  'Carcasse',
] as const;

export const views = [
  'Vue dégagée',
  'Vue mer',
  'Vue montagne',
  'Vue sur jardin',
  'Vue sur ville',
  'Vue sur cour',
  'Vue panoramique',
  'Vue sur forêt',
] as const;

export const kitchenTypes = [
  'Aménagée',
  'Équipée',
  'Américaine / Ouverte',
  'Semi-ouverte',
  'Fermée',
  'Indépendante',
  'Cuisine avec îlot central',
  'Coin cuisine',
  'Sans cuisine',
  'À aménager',
] as const;

// Types de transactions
export const transactionTypes = [
  {
    id: 'estimation',
    label: 'Estimation',
    description: 'Estimer la valeur d\'un bien',
  },
  {
    id: 'sale',
    label: 'Vente',
    description: 'Vente classique',
  },
  {
    id: 'rent',
    label: 'Location',
    description: 'Location longue durée',
  },
  {
    id: 'short-rent',
    label: 'Location courte durée',
    description: 'Location saisonnière',
  },
] as const;

// Statuts valides pour les propriétés (correspond à l'ENUM MySQL)
export const PROPERTY_STATUSES = [
  'for-sale',
  'for-rent',
  'for-short-rent', 
  'sold',
  'rented',
  'archived',
  'estimation'
] as const;

export type PropertyStatus = typeof PROPERTY_STATUSES[number];

export type TransactionType = typeof transactionTypes[number]['id'];
export type ApartmentType = typeof apartmentTypes[number];
export type HouseType = typeof houseTypes[number];
export type Condition = typeof conditions[number];
export type View = typeof views[number];
export type KitchenType = typeof kitchenTypes[number];